import { render, staticRenderFns } from "./ShareConfirmation.vue?vue&type=template&id=4998a46c&"
import script from "./ShareConfirmation.vue?vue&type=script&lang=js&"
export * from "./ShareConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports